import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f5c843ec&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c843ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5c843ec')) {
      api.createRecord('f5c843ec', component.options)
    } else {
      api.reload('f5c843ec', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f5c843ec&scoped=true&", function () {
      api.rerender('f5c843ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28bm7pFb5xAJg/JS/comp/SearchFilterTokens.vue"
export default component.exports